import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "sales-games",
      path: "games",
      meta: {
        auth: () => store.getters.isEmployee(),
        icon: "trophy",
        title: i18n.global.t("Sales Games"),
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/SalesGames"),
    },
  ],

  dialogs: [],
};
